import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { IoClose, IoMenu } from "react-icons/io5";
import scrollToTop from "../components/scroll-to-top";

const Header = () => {
  const location = useLocation(); // Hook to get the current location
  const [activePage, setActivePage] = useState(location.pathname);

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  useEffect(() => {
    setActivePage(location.pathname); // Update the active page when the location changes
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      // const heroHeight = document.getElementById("hero")?.offsetHeight || 0;
      setScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const logoSrc =
    location.pathname === "/services" ||
    location.pathname === "/landing-more" ||
    location.pathname === "/design" ||
    location.pathname === "/development" ||
    location.pathname === "/hosting-maintenance" ||
    location.pathname === "/consulting" ||
    location.pathname === "/services/basic-sitecare" ||
    location.pathname === "/services/pro-sitecare" ||
    location.pathname === "/services/premium-sitecare" ||
    location.pathname === "/services/elite-sitecare" ||
    location.pathname === "/services/site-pulse-plan" ||
    location.pathname === "/services/quarterly-clarity-plan" ||
    location.pathname === "/services/web-partner-plan" ||
    location.pathname === "/services/site-check" ||
    location.pathname === "/services/clarity-call" ||
    location.pathname === "/services/message-check" ||
    location.pathname === "/booking" ||
    location.pathname === "/services/link-in-bio" ||
    location.pathname === "/services/landing-page" ||
    location.pathname === "/services/email-design" ||
    location.pathname === "/services/tech-check"
      ? "https://dye493vmtifvj.cloudfront.net/aws-logos/full/fullwhitelogo1.webp"
      : "https://dye493vmtifvj.cloudfront.net/aws-logos/full/fullpurplelogo1.webp";

  const getScrolledClass = () => {
    if (!scrolled) return "header-default";

    switch (location.pathname) {
      case "/landing-more":
        return "services-scrolled";
      case "/design":
        return "services-scrolled";
      case "/development":
        return "services-scrolled";
      case "/hosting-maintenance":
        return "services-scrolled";
      case "/services/basic-sitecare":
        return "services-scrolled";
      case "/services/pro-sitecare":
        return "services-scrolled";
      case "/services/premium-sitecare":
        return "services-scrolled";
      case "/services/elite-sitecare":
        return "services-scrolled";
      case "/services/tech-check":
        return "services-scrolled";
      case "/services/message-check":
        return "services-scrolled";
      case "/services/site-pulse-plan":
        return "services-scrolled";
      case "/services/quarterly-clarity-plan":
        return "services-scrolled";
      case "/services/web-partner-plan":
        return "services-scrolled";
      case "/services/site-check":
        return "services-scrolled";
      case "/services/clarity-call":
        return "services-scrolled";
      case "/services/link-in-bio":
        return "services-scrolled";
      case "/services/landing-page":
        return "services-scrolled";
      case "/services/email-design":
        return "services-scrolled";
      case "/booking":
        return "services-scrolled";
      case "/consulting":
        return "services-scrolled";
      case "/services":
        return "landing-page-scrolled";
      case "/about":
        return "about-scrolled";
      default:
        return "scrolled";
    }
  };
  const isWhiteNav = ["/services"].some((path) => location.pathname === path);
  const isWhiteDesktopNav = ["/services"].some(
    (path) => location.pathname === path,
  );
  const isServicesIpadNav = [
    "/services/tech-check",
    "/design",
    "/development",
    "/consulting",
    "/hosting-maintenance",
    "/landing-more",
    "/services/basic-sitecare",
    "/services/pro-sitecare",
    "/services/premium-sitecare",
    "/services/elite-sitecare",
    "/services/site-pulse-plan",
    "/services/quarterly-clarity-plan",
    "/services/web-partner-plan",
    "/services/site-check",
    "/services/clarity-call",
    "/services/message-check",
    "/services/link-in-bio",
    "/services/email-design",
    "/services/landing-page",
    "/booking",
  ].some((path) => location.pathname.startsWith(path));
  return (
    <>
      <div
        className={`header ${getScrolledClass()} ? "" ${
          isWhiteNav ? "white-nav" : ""
        } ${isWhiteDesktopNav ? "white-dnav" : ""} `}
      >
        <Link
          className={`menu-item ${activePage === "/" ? "active" : ""}`}
          to="/"
          onClick={() => {
            scrollToTop();
          }}
        >
          <div className="logo">
            <img src={logoSrc} alt="acrylic full logo" />
          </div>
        </Link>
        <div className="menu">
          <ul className="menuop">
            <li>
              <Link
                className={`menu-item ${
                  activePage === "/about" ? "active" : ""
                }`}
                onClick={() => {
                  scrollToTop();
                }}
                to="/about"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                className={`menu-item ${
                  activePage === "/services" ? "active" : ""
                }`}
                onClick={() => {
                  scrollToTop();
                }}
                to="/services"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                className={`menu-item ${
                  activePage === "/projects" ? "active" : ""
                }`}
                onClick={() => {
                  scrollToTop();
                }}
                to="/projects"
              >
                Projects
              </Link>
            </li>
            <li>
              <Link
                className={`menu-item ${
                  activePage === "/contact" ? "active" : ""
                }`}
                onClick={() => {
                  scrollToTop();
                }}
                to="/contact"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div
          className={` ipad-alt ${getScrolledClass()} ? "" ${
            isWhiteNav ? "white-nav" : ""
          } ${isServicesIpadNav ? "white-services-nav" : ""} `}
        >
          <span
            className={`menu-icons ${isWhiteNav ? "white-nav" : ""} ${
              isServicesIpadNav ? "white-services-nav" : ""
            }`}
            onClick={toggleDropdown}
          >
            {isDropdownVisible ? (
              <IoClose className="menu-close-icon" />
            ) : (
              <IoMenu
                className={`menu-open-icon  ${isWhiteNav ? "white-nav" : ""} ${
                  isServicesIpadNav ? "white-services-nav" : ""
                } `}
              />
            )}
          </span>
          <div
            className={`alt-menu-dropdown ${
              isDropdownVisible ? "show" : "hiding"
            } ${isWhiteNav ? "white-nav" : ""} ${
              isServicesIpadNav ? "white-services-nav" : ""
            }`}
          >
            <div className="ipad-menu ">
              <div>
                <Link
                  className="menu-it"
                  to="/"
                  onClick={() => {
                    toggleDropdown();
                    scrollToTop();
                  }}
                >
                  Home
                </Link>
              </div>
              <hr />
              <div>
                <Link
                  className="menu-it"
                  to="/about"
                  onClick={() => {
                    toggleDropdown();
                    scrollToTop();
                  }}
                >
                  About us
                </Link>
              </div>

              <hr />
              <div>
                <Link
                  className="menu-it"
                  to="/services"
                  onClick={() => {
                    toggleDropdown();
                    scrollToTop();
                  }}
                >
                  Services
                </Link>
              </div>

              <hr />
              <div>
                <Link
                  className="menu-it"
                  to="/projects"
                  onClick={() => {
                    toggleDropdown();
                    scrollToTop();
                  }}
                >
                  projects
                </Link>
              </div>
              <hr />
              <div>
                <Link
                  className="menu-it"
                  to="/contact"
                  onClick={() => {
                    toggleDropdown();
                    scrollToTop();
                  }}
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
